import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User seeked forward or backward in a video',
  name: 'seeked_video',
  params: [
    {
      description: 'The duration of the seek in seconds',
      name: 'duration',
      required: true,
      type: 'number',
    },
    {
      description: 'The ID of the clip',
      name: 'id',
      required: true,
      type: 'string',
    },
    {
      description: 'The time format used when seeking',
      name: 'timeFormat',
      required: true,
      type: 'enum',
      values: ['standard', 'frames', 'timecode'],
    },
    {
      description: 'The direction of the seek',
      name: 'type',
      required: true,
      type: 'enum',
      values: ['forward', 'backward'],
    },
  ],
};

export default META;
